import React from "react";

const OrderUpdateIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M14.708 5.29427C14.0913 4.67331 13.3577 4.18057 12.5496 3.84446C11.7415 3.50836 10.8749 3.33553 9.99967 3.33594C8.23156 3.33594 6.53587 4.03832 5.28563 5.28856C4.03539 6.5388 3.33301 8.23449 3.33301 10.0026C3.33301 11.7707 4.03539 13.4664 5.28563 14.7167C6.53587 15.9669 8.23156 16.6693 9.99967 16.6693C13.108 16.6693 15.6997 14.5443 16.4413 11.6693H14.708C14.3647 12.6439 13.7275 13.4879 12.8841 14.085C12.0408 14.682 11.033 15.0026 9.99967 15.0026C8.67359 15.0026 7.40182 14.4758 6.46414 13.5381C5.52646 12.6005 4.99967 11.3287 4.99967 10.0026C4.99967 8.67652 5.52646 7.40475 6.46414 6.46707C7.40182 5.52939 8.67359 5.0026 9.99967 5.0026C11.383 5.0026 12.6163 5.57761 13.5163 6.48594L10.833 9.16927H16.6663V3.33594L14.708 5.29427Z" fill="white" />
        </svg>
    )
}

export default OrderUpdateIcon;

